import { BlocksIconPrint } from 'blocks-nextjs/blocks-web-components/components/icon/icons/print';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconPrint = createComponent({ react: React, tagName: 'cat-icon-print', elementClass: BlocksIconPrint });
